<script lang="ts">
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import HelpPopup from "@/components/HelpPopup.vue";
import SearchComponent from "@/components/SearchComponent.vue";
import {Drug, DrugStatus} from "@/models/Drug/Drug";
import HasLabel from "@/models/HasLabel";
import {DrugSource} from "@/models/Drug/DrugProduct";
import Axios from "axios";

@Component({
    name: "SearchPrescriptionDetailComponent",
    components: {HelpPopup},
})
export default class SearchPrescriptionDetailComponent extends SearchComponent {
    @Prop({default: null}) private equivalentDrugs!: Drug.EquivalentDrug[];
    private mockOptionLabel!: Function | undefined;

    printLabel(o: any, long: boolean = false) {
        if (o.id == 0 && this.createNewObject) return this.createNewLabel;
        o = this.toModelType(o);
        if (this.mockOptionLabel && this.equivalentDrugs.length > 0) return this.mockOptionLabel(o);
        if (this.optionLabel) return this.optionLabel(o);
        else if (o instanceof HasLabel) return this.toModelType(o).getLabel(long);
        else return o ? o.id : "";
    }

    @Watch('equivalentDrugs') onEquivalentDrugsChange() {
        if (this.equivalentDrugs.length > 0) {
            this.addObject(this.equivalentDrugs);
            this.mockOptionLabel = (e: any) => `NDC: ${e.ndc} - Name: ${e.productNameShort} - PS: ${e.packageSize} - Marketer: ${e.marketer}${e.quantityOnHand !== undefined && e.quantityOnHand !== null ? ' - QTY: ' + e.quantityOnHand : ''}`;
            this.focus();
        }
    }

    public addObject(newObjects: Drug.EquivalentDrug[]) {

        const transformedDrugs = newObjects.map(eq => ({
            source: DrugSource.GsddFederal,
            drugId: eq.packageID ?? 0,
            ndc: eq.ndc ?? "",
            marketer: eq.marketer ?? "",
            packageSize: eq.packageSize ?? 0,
            productNameShort: eq.productNameLong ?? "",
            activeStatus: eq.activeStatus ?? DrugStatus.DrugStatusEnum.Active,
            licenseType: "",
            billingUnit: "",
            quantityOnHand: eq.onHand ?? 0
        }));

        const models = transformedDrugs.map((o) => this.toModelType(o));

        this.objects = [];
        models.forEach(m => {
            if (!this.objects.some(o => o.id === m.id)) {
                this.objects.push(m);
            }
        });
    }

    forceReload(value: any) {
        const url = this.getByIdURL || this.searchURL;

        const dropdown: any = this.$refs.dropdown;
        const toggleLoading = dropdown?.toggleLoading;

        if (toggleLoading) toggleLoading(true);
        Axios.get(`${url}/${value.id}`, {params: this.paramsInGetById})
            .then((response) => {
                if (value?.id) {
                    this.object = this.toModelType(response.data);
                }
            })
            .catch((error) => {
                console.warn(error);
            })
            .finally(() => {
                if (toggleLoading) toggleLoading(false);
                this.mockOptionLabel = undefined;
            });
    }
}

</script>
